// extracted by mini-css-extract-plugin
export default {"FilterSwitch":"styles_FilterSwitch__u3hWs","option":"styles_option__mI+Zy","active":"styles_active__BIyQX","count":"styles_count__HDJfi"};